/* eslint-disable */
import { memo, useState, useEffect, useLayoutEffect, useRef } from "react";
import { useFormik, getIn, FieldArray, Form, Formik } from "formik";
import {
  initialValues,
  validationSchema
} from "../../../../helpers/FormDetails/ProposalDetails/GeneralDetails";
import CustomDatePicker from "../../../../shared/CustomDatePicker";
import CustomRadioButton from "../../../../shared/CustomRadioButton";
import CustomSelect from "../../../../shared/CustomSelect";
import CustomTextField from "../../../../shared/CustomTextField";
import Button from "@mui/material/Button";
import {
  OPTIONS,
  findKeysByValue,
  findValueByLabel
} from "../../../../helpers/FormDetails/ProposalDetails/resources";
import { OPTIONS as NationalityOptions } from "../../../../helpers/Dashboard/resources";
import CustomModal from "src/shared/CustomModal";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomAutocomplete from "src/shared/CustomAutocomplete";
import { useMutation } from "react-query";
import { countryCall, subOccupationCall } from "src/services/Master";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { SET_TOAST_ERROR, setStepDetails } from "src/redux/Actions/common";
import { setProposerGeneralPostDetails } from "src/redux/Thunk";
import { setCountry, setSubOccupationData } from "src/redux/Actions/proposerDetails";
import {
  handelIndianCurrencyChange,
  handleUppercaseChange,
  onChangeIndianCurrency
} from "src/helpers/FormDetails";
import CustomCheckBox from "src/shared/CustomCheckBox";
// import { Tooltip } from "@mui/material";
import ConfirmationModal from "src/shared/ConfirmationModal";
import CustomHelperText from "src/shared/CustomHelperText";
import dayjs from "dayjs";
import ProportionateLife from "./ProportionateLife";
import { JointCoverageType, labels, partners } from "src/config/constant";
import { Tooltip } from "@mui/material";
// import CustomBackDrop from "src/shared/CustomBackDrop";
// import useDebounce from "src/utils/hooks/useDebounce";

function GeneralDetails() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const generalProposerDetailsSchema = mefSchema?.generalProposerDetailsSchema || {};
  const generalDetails = useAppSelector((state) => state.proposerDetails.general) || initialValues;
  const isJointLife =
    useAppSelector((state) => state?.isJointAddendum?.isJointState) === JointCoverageType.YES;
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId);
  const isNotProportionateParentLife = useAppSelector(
    (state) => !state.common?.isProportionateParentLead
  );
  // const memberId = useAppSelector((state) => state.proposerDetails.memberId);
  const dispatch = useDispatch();
  const [subOccupationOptions, setSubOccupationOptions] = useState([]);
  // const leadId = useAppSelector((state) => state.common.leadId);
  // const tableData = useAppSelector((state) => state.dashboard.tableData);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const proposerStepNo = useAppSelector((state) => state.stepDetails?.proposerStepNo);
  const productId = useAppSelector((state) => state.common.productId);
  const [countryOptions, setCountryOptions] = useState([]);
  const combinedSelector = (state: {
    masterdata_reducer: {
      genderDetails: any;
      educationDetails: any;
      occupationDetails: any;
      salutationDetails: any;
      maritalstatusDetails: any;
      subOccupationDetails: any;
      relationshipDetails: any;
    };
  }) => {
    const genderData = state.masterdata_reducer.genderDetails;
    const educationData = state.masterdata_reducer.educationDetails;
    const occupationData = state.masterdata_reducer.occupationDetails;
    const salutationData = state.masterdata_reducer.salutationDetails;
    const maritalStatusData = state.masterdata_reducer.maritalstatusDetails;
    const subOccupationData = state.masterdata_reducer.subOccupationDetails;
    // const relationData = state.masterdata_reducer.relationshipDetails;

    const educationDataList: string[] = educationData ? Object.values(educationData) : [];
    const genderDataList: string[] = genderData ? Object.values(genderData) : [];
    const occupationDataList: string[] = occupationData ? Object.values(occupationData) : [];
    const salutationDataList: string[] = salutationData ? Object.values(salutationData) : [];
    const maritalStatusDataList: string[] = maritalStatusData
      ? Object.values(maritalStatusData)
      : [];
    const subOccupationDataList: string[] = subOccupationData
      ? Object.values(subOccupationData)
      : [];

    return {
      genderDataList,
      educationDataList,
      occupationDataList,
      salutationDataList,
      maritalStatusDataList,
      subOccupationDataList
      // relationDataList
    };
  };
  const masterData = useAppSelector((state) => state.masterdata_reducer);
  const {
    genderDataList,
    educationDataList,
    occupationDataList,
    maritalStatusDataList
    // relationDataList
    // subOccupationDataList
  } = useSelector(combinedSelector);
  // const { mutate: mutateSetMemberDetails } = useMutation(["setMemberDetailsIntoDB"], () =>
  //   setMemberDetails(memberId!, { addressLine1: undefined })
  // );
  const [sharePercentErrorStatus, setSharePercentErrorStatus] = useState<boolean[]>([]);
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: generalDetails,
    validationSchema: validationSchema(
      partnerId,
      productId,
      masterData?.salutationDetails,
      generalProposerDetailsSchema
    ),
    onSubmit: (fieldValues) => {
      if (sharePercentErrorStatus?.some(Boolean)) {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            duration: 4000,
            message: "Please adjust share% among proportionate members"
          })
        );
      } else if (fieldValues.isJointJourney || fieldValues.isProportionateLife) {
        setOpenConfirmationModal((prev) => !prev);
      } else {
        handleJointJourneyProposalSubmit();
      }
    }
  });
  const {
    isValid,
    errors,
    handleBlur,
    setFieldTouched,
    touched,
    values,
    setFieldValue,
    handleChange,
    handleSubmit,
    setValues
  } = formik;
  const prevOccupationRef = useRef(values.occupationCode);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState<boolean>(false);
  // const debounceCountryValue = useDebounce(values.countryOfResidence, 200);
  const [changeModalOpen, setChangeModalOpen] = useState<boolean>(false);
  const [fieldName, setFieldName] = useState<string[]>([]);

  useEffect(() => {
    const percent = Number(values.primaryProportionatePercent || 0);
    const loanAmount = Number(values.totalLoanAmountOpted || 0);

    if (
      (!values.primarySumAssured || values.primarySumAssured === "") &&
      percent > 0 &&
      loanAmount > 0
    ) {
      values.primarySumAssured = String(Math.floor((loanAmount * percent) / 100));
    }

    if (!varsHasProportionate(values)) {
      values.proportionate = initialValues.proportionate;
    }

    setValues(values);
  }, [generalDetails]);

  function varsHasProportionate(v: any) {
    return v && Array.isArray(v.proportionate);
  }

  useEffect(() => {
    if (values?.genderCode === "F" && values?.occupationCode === "HW") {
      setFieldValue("housewifeFlag", true);
      setFieldValue("annualIncome", "");
    } else {
      setFieldValue("housewifeFlag", false);
    }
  }, [values?.occupationCode, values?.annualIncome, values?.genderCode]);

  useEffect(() => {
    if (!masterData?.salutationDetails || !values?.title) return;
    setFieldValue("titleCode", findValueByLabel(masterData?.salutationDetails, values?.title));
  }, [values?.title]);

  useEffect(() => {
    setFieldValue(
      "maritalStatusCode",
      findKeysByValue(masterData.maritalstatusDetails, values.maritalStatus)
    );
  }, [values.maritalStatus]);

  useEffect(() => {
    setFieldValue(
      "educationQualificationCode",
      findKeysByValue(masterData.educationDetails, values.educationQualification)
    );
  }, [values.educationQualification]);

  useEffect(() => {
    setFieldValue(
      "occupationCode",
      findKeysByValue(masterData.occupationDetails, values.occupation)
    );
  }, [values.occupation]);

  useEffect(() => {
    setFieldValue("genderCode", findKeysByValue(masterData.genderDetails, values.gender));
    setFieldValue(
      "title",
      generalDetails?.title
        ? generalDetails?.title
        : masterData?.salutationDetails[values?.genderCode!][0].label
    );
  }, [values.gender]);

  useEffect(() => {
    setFieldValue(
      "jointGenderCode",
      findKeysByValue(masterData.genderDetails, values?.jointGender!)
    );
  }, [values.jointGender]);

  // useEffect(() => {
  //   setFieldValue(
  //     "jointRelationshipCode",
  //     findKeysByValue(masterData.relationshipDetails, values?.jointRelationship!)
  //   );
  // }, [values?.jointRelationship]);

  useEffect(() => {
    setFieldValue(
      "nationalityCode",
      findKeysByValue(NationalityOptions.nationality, values.nationality)
    );
  }, [values.nationality]);

  const handleGenderClick = () => {
    if (values?.genderCode && masterData.salutationDetails[values.genderCode]?.length) {
      setFieldValue(
        "title",
        generalDetails?.title
          ? generalDetails?.title
          : masterData?.salutationDetails[values?.genderCode!][0].label
      );
    }
  };

  useLayoutEffect(() => {
    handleGenderClick();
  }, [values.genderCode]);

  const { mutate: mutateSubOccupation } = useMutation(subOccupationCall, {
    retry: false,
    onSuccess: async (response, variables) => {
      const subOccupationResponse = response.data;
      const subOccupationArray = subOccupationResponse.reduce(
        (acc: string[], result: Record<string, any>) => {
          acc.push(result?.name);
          return acc;
        },
        []
      );
      setSubOccupationOptions(subOccupationArray);
      if (response.data?.length) {
        const exactSubOccupationData = await response.data?.filter(
          (subOccupation: Record<string, any>) => subOccupation?.name === variables?.name
        );
        setFieldValue("subOccupationCode", exactSubOccupationData[0]?.code);
        store.dispatch(setSubOccupationData(exactSubOccupationData[0]));
      }
    }
  });

  const { mutate: mutateCountry } = useMutation(countryCall, {
    retry: false,
    onSuccess: async (response, variables) => {
      const countryResponse = response.data;
      const countryOccupationArray = countryResponse.reduce(
        (acc: string[], result: Record<string, any>) => {
          acc.push(result?.name);
          return acc;
        },
        []
      );
      setCountryOptions(countryOccupationArray);
      if (response.data?.length) {
        const exactCountryData = await response.data?.filter(
          (country: Record<string, any>) => country?.name === variables?.name
        );
        setFieldValue("countryOfResidenceCode", exactCountryData[0]?.code);
        store.dispatch(setCountry(exactCountryData[0]));
      }
    }
  });

  const handleSubOccupationChange = async (value: string) => {
    // console.log("entering suboccupation");
    await setFieldValue("subOccupation", value);
    if (value) mutateSubOccupation({ name: value });
  };

  const handleCountryChange = async (value: string) => {
    // console.log("entering country");
    await setFieldValue("countryOfResidence", value);
    if (value) mutateCountry({ name: value });
  };

  const handleJointJourneyProposalSubmit = () => {
    if (proposalStatus !== "MEF Submitted") {
      store.dispatch(setProposerGeneralPostDetails(values, { proposerStepNo: proposerStepNo + 1 }));
      window.scrollTo(0, 0);
    } else {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 4000,
          message: "MEF Already Submitted"
        })
      );
    }
  };

  const handleProposerGeneralForm = () => {
    const changedFields: string[] = [];
    const fieldsToCheck = ["gender", "firstName", "middleName", "lastName", "dob"];
    const fieldNameMap: { [key: string]: string } = {
      gender: "Gender",
      firstName: "First Name",
      middleName: "Middle Name",
      lastName: "Last Name",
      dob: "Date of Birth"
    };
    fieldsToCheck.forEach((field) => {
      const formattedFieldName = fieldNameMap[field] || field;
      if ((values as any)[field] !== (generalDetails as any)[field]) {
        changedFields.push(formattedFieldName);
      }
    });
    if (changedFields.length > 0 && isValid) {
      setFieldName(changedFields);
      setChangeModalOpen(true);
      setModalOpen(false);
    } else if (isValid && !values.isJointJourney && !values.isProportionateLife) {
      setChangeModalOpen(false);
      setModalOpen(false);
      submitForm();
    } else {
      if (!isValid) {
        setModalOpen(true);
      }
      handleSubmit();
    }
  };

  const submitForm = () => {
    store.dispatch(setProposerGeneralPostDetails(values, { proposerStepNo: proposerStepNo + 1 }));
    window.scrollTo(0, 0);
    handleSubmit();
  };

  const handleChangeMobile = (event: any) => {
    const { name, value } = event.target;

    if (name === "mobileNo" && value !== generalDetails.mobileNo) {
      setValues({
        ...values,
        [name]: value,
        telePhoneNo: generalDetails.mobileNo
      });
    } else {
      setValues({
        ...values,
        [name]: value
      });
    }
  };

  useEffect(() => {
    if (values.nationalityCode === "RES") {
      setFieldValue("countryOfResidence", "");
      setFieldValue("countryOfResidenceCode", "");
      setFieldValue("cityOfResidence", "");
      setFieldValue("dateOfLastEntry", "");
    }
    if (["OT", "SE"].includes(values.occupationCode!)) {
      // setFieldValue("nameOfOrganization", "");
      setFieldValue("designation", "");
    }
    if (!["OT"].includes(values.occupationCode!)) {
      setFieldValue("subOccupation", "");
      setFieldValue("subOccupationCode", "");
    }
  }, [values.nationalityCode, values.occupationCode]);

  useEffect(() => {
    if (partners.JIO === partnerId && ["SE"].includes(values.occupationCode!)) {
      setFieldValue("nameOfOrganization", "");
    }
  }, [partnerId, values.occupationCode, partners.JIO]);

  useEffect(() => {
    if (!values.isJointJourney) {
      setFieldValue("jointFirstName", "");
      setFieldValue("jointMiddleName", "");
      setFieldValue("jointLastName", "");
      setFieldValue("jointMobileNo", "");
      setFieldValue("jointPan", "");
      setFieldValue("jointAnnualIncome", "");
      setFieldValue("jointGender", "");
      setFieldValue("jointGenderCode", "");
      setFieldValue("jointDob", "");
    }
  }, [values.isJointJourney]);

  useEffect(() => {
    if (!values.isProportionateLife) {
      setFieldValue("proportionate", initialValues.proportionate);
      setFieldValue("totalLoanAmountOpted", initialValues.totalLoanAmountOpted);
      setFieldValue("primaryProportionatePercent", initialValues.primaryProportionatePercent);
      setFieldValue("primarySumAssured", initialValues.primarySumAssured);
    }
  }, [values.isProportionateLife]);

  const handleAddingMoreProportionate = () => {
    values?.proportionate &&
      values?.proportionate?.length < 4 &&
      setFieldValue("proportionate", [
        ...(values.proportionate || []),
        {
          nameOfProportionateLife: "",
          proprtionateDob: "",
          proprtionatePercent: "",
          proprtionateGender: ""
        }
      ]);
  };

  const handleRemoveClick = (indexToRemove: number) => {
    if (!values.proportionate) {
      return;
    }
    const updatedProportionate = [...values.proportionate];
    updatedProportionate.splice(indexToRemove, 1);
    formik.setFieldValue("proportionate", updatedProportionate);
  };
  const handleCheckboxChange = (name: string) => {
    const otherCheckboxes = ["isJointJourney", "isProportionateLife"].filter(
      (checkbox) => checkbox !== name
    );
    otherCheckboxes.forEach((checkbox) => formik.setFieldValue(checkbox, false));
  };
  useEffect(() => {
    if (values.electronicAccount === "No") {
      setFieldValue("eiaNumber", "");
    }
  }, [values.electronicAccount]);

  useEffect(() => {
    const current = values.occupationCode || "";
    const prev = prevOccupationRef.current || "";
    const businessTypes = ["BO", "SE"];
    const isBusinessType = businessTypes.includes(current);
    if (!isBusinessType) {
      if (values.businessOwner !== false) {
        setFieldValue("businessOwner", false, false);
      }
    }
    if (current !== prev && isBusinessType) {
      setFieldValue("businessOwner", true, false);
    }
    prevOccupationRef.current = current;
  }, [values.occupationCode]);

  const handlePrimarySumAssuredChange = async (event: any) => {
    await handleChange(event);
    const sumAssured = Number(event.target.value || 0);
    const loanAmount = Number(values?.totalLoanAmountOpted || 0);
    if (loanAmount > 0 && sumAssured > 0) {
      const percent = (sumAssured / loanAmount) * 100;
      setFieldValue("primaryProportionatePercent", Number(percent.toFixed(2)));
    } else {
      setFieldValue("primaryProportionatePercent", "");
    }
  };

  useEffect(() => {
    const sumAssured = Number(values?.primarySumAssured || 0);
    const loanAmount = Number(values?.totalLoanAmountOpted || 0);

    if (loanAmount > 0 && sumAssured > 0) {
      const percent = (sumAssured / loanAmount) * 100;
      setFieldValue("primaryProportionatePercent", Number(percent.toFixed(2)));
    } else {
      setFieldValue("primaryProportionatePercent", "");
    }
  }, [values?.totalLoanAmountOpted]);

  useEffect(() => {
    const percent = Number(values?.primaryProportionatePercent || 0);
    const loanAmount = Number(values?.totalLoanAmountOpted || 0);
    const existingSum = values?.primarySumAssured;

    if (percent > 0 && loanAmount > 0 && (existingSum === undefined || existingSum === "")) {
      const derived = Math.floor((loanAmount * percent) / 100);
      setFieldValue("primarySumAssured", derived);
    }
  }, [values?.primaryProportionatePercent, values?.totalLoanAmountOpted]);

  console.log(["SE", ""].includes(values.occupationCode!));
  const salutationOptions =
    values?.genderCode && masterData?.salutationDetails[values.genderCode]
      ? masterData.salutationDetails[values.genderCode].map(
          (item: { label: string; value: string }) => item.label
        )
      : [];

  return (
    <>
      {openConfirmationModal && (
        <ConfirmationModal
          text={
            <div>
              <p>{values.isJointJourney ? labels?.joint?.text : labels?.proportionate?.text}</p>
              <p className="text-sm mt-3">
                {values.isJointJourney ? labels.joint.cta : labels.proportionate.cta}
              </p>
            </div>
          }
          onNext={handleJointJourneyProposalSubmit}
          onCancel={() => setOpenConfirmationModal((prev) => !prev)}
        />
      )}
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      {changeModalOpen && (
        <ConfirmationModal
          text={
            <div>
              <p>
                The
                {fieldName.map((field, index) => (
                  <span key={index}>
                    <span className="text-mediumElectricBlue">{" " + field}</span>
                    {index !== fieldName.length - 1 ? "," : ""}
                  </span>
                ))}
                <span> </span>has been changed and additional proofs will be called for establishing
                the same.
              </p>
            </div>
          }
          onNext={() => {
            if (values.isJointJourney || values.isProportionateLife) {
              handleProposerGeneralForm();
              values.requirementFlag = true;
              setChangeModalOpen(false);
              setModalOpen(false);
              setOpenConfirmationModal(true);
            } else {
              handleProposerGeneralForm();
              values.requirementFlag = true;
              store.dispatch(
                setProposerGeneralPostDetails(values, { proposerStepNo: proposerStepNo + 1 })
              );

              window.scrollTo(0, 0);
              setChangeModalOpen(false);
            }
          }}
          onCancel={() => {
            setChangeModalOpen(false);
          }}
        />
      )}
      <div className="pr-10 pl-10.25 pt-8 bg-white">
        <div className="space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
            {generalProposerDetailsSchema.title.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.title.required}
                name="title"
                label={generalProposerDetailsSchema.title.label}
                options={salutationOptions}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                value={values?.title}
                error={errors?.title}
                touched={touched?.title}
              />
            )}

            {generalProposerDetailsSchema.gender.visible && (
              <CustomRadioButton
                requiredStar={generalProposerDetailsSchema.gender.required}
                className={`${
                  values.title === "Others"
                    ? "col-span-1 sm:col-span-1 md:col-span-2 lg:col-span-3"
                    : "col-span-1 sm:col-span-1 md:col-span-2 lg:col-span-3"
                }`}
                name="gender"
                label={generalProposerDetailsSchema.gender.label}
                options={genderDataList}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                error={getIn(errors, "gender")}
                touched={getIn(touched, "gender")}
                defaultValue={values.gender}
              />
            )}

            {generalProposerDetailsSchema.firstName.visible && (
              <CustomTextField
                requiredStar={generalProposerDetailsSchema.firstName.required}
                label={generalProposerDetailsSchema.firstName.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.firstName}
                name="firstName"
                error={getIn(errors, "firstName")}
                touched={getIn(touched, "firstName")}
              />
            )}

            {generalProposerDetailsSchema.middleName.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.middleName.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.middleName}
                name="middleName"
                error={errors.middleName}
                touched={touched.middleName}
              />
            )}

            {generalProposerDetailsSchema.lastName.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.lastName.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.lastName}
                name="lastName"
                error={errors.lastName}
                touched={touched.lastName}
              />
            )}

            {generalProposerDetailsSchema.dob.visible && (
              <CustomDatePicker
                disableFuture
                requiredStar={generalProposerDetailsSchema.dob.required}
                label={generalProposerDetailsSchema.dob.label}
                setFieldValue={setFieldValue}
                name="dob"
                value={values.dob}
                error={errors.dob}
                touched={touched.dob}
                setFieldTouched={setFieldTouched}
              />
            )}

            {generalProposerDetailsSchema.maritalStatus.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.maritalStatus.required}
                label={generalProposerDetailsSchema.maritalStatus.label}
                options={maritalStatusDataList}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="maritalStatus"
                value={values.maritalStatus}
                error={errors.maritalStatus}
                touched={touched.maritalStatus}
              />
            )}

            {generalProposerDetailsSchema.nationality.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.nationality.required}
                label={generalProposerDetailsSchema.nationality.label}
                options={OPTIONS.nationality}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="nationality"
                value={values.nationality}
                error={errors.nationality}
                touched={touched.nationality}
              />
            )}

            {!["RES", ""].includes(values.nationalityCode!) &&
              generalProposerDetailsSchema.countryOfResidence.visible && (
                <CustomAutocomplete
                  onChange={handleCountryChange}
                  setFieldTouched={setFieldTouched}
                  label={generalProposerDetailsSchema.countryOfResidence.label}
                  name="countryOfResidence"
                  value={values.countryOfResidence}
                  setFieldValue={setFieldValue}
                  error={errors.countryOfResidence}
                  touched={touched.countryOfResidence}
                  options={countryOptions}
                />
              )}

            {!["RES", ""].includes(values.nationalityCode!) &&
              generalProposerDetailsSchema.cityOfResidence.visible && (
                <CustomTextField
                  requiredStar={generalProposerDetailsSchema.cityOfResidence.required}
                  label={generalProposerDetailsSchema.cityOfResidence.label}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.cityOfResidence}
                  name="cityOfResidence"
                  error={getIn(errors, "cityOfResidence")}
                  touched={getIn(touched, "cityOfResidence")}
                />
              )}

            {!["RES", ""].includes(values.nationalityCode!) &&
              generalProposerDetailsSchema.dateOfLastEntry.visible && (
                <CustomDatePicker
                  requiredStar={generalProposerDetailsSchema.dateOfLastEntry.required}
                  disableFuture
                  minDate={dayjs(new Date(values?.dob.split("/").reverse().join("-")))}
                  label={generalProposerDetailsSchema.dateOfLastEntry.label}
                  setFieldValue={setFieldValue}
                  name="dateOfLastEntry"
                  value={values.dateOfLastEntry}
                  error={errors.dateOfLastEntry}
                  touched={touched.dateOfLastEntry}
                  setFieldTouched={setFieldTouched}
                />
              )}

            {generalProposerDetailsSchema.educationQualification.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.educationQualification.required}
                label={generalProposerDetailsSchema.educationQualification.label}
                options={educationDataList}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="educationQualification"
                value={values.educationQualification}
                error={errors.educationQualification}
                touched={touched.educationQualification}
              />
            )}

            {generalProposerDetailsSchema.mobileNo.visible && (
              <CustomTextField
                requiredStar={generalProposerDetailsSchema.mobileNo.required}
                label={generalProposerDetailsSchema.mobileNo.label}
                onChange={handleChangeMobile}
                handleBlur={handleBlur}
                value={values.mobileNo}
                name="mobileNo"
                error={errors.mobileNo}
                touched={touched.mobileNo}
              />
            )}

            {generalProposerDetailsSchema.telePhoneNo.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.telePhoneNo.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.telePhoneNo || ""}
                name="telePhoneNo"
                error={errors.telePhoneNo}
                touched={touched.telePhoneNo}
              />
            )}

            {generalProposerDetailsSchema.email.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.email.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.email}
                name="email"
                error={errors.email}
                touched={touched.email}
              />
            )}

            {generalProposerDetailsSchema.occupation.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.occupation.required}
                label={generalProposerDetailsSchema.occupation.label}
                options={occupationDataList}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="occupation"
                value={values.occupation}
                error={errors.occupation}
                touched={touched.occupation}
              />
            )}

            {values.occupationCode === "OT" &&
              generalProposerDetailsSchema.subOccupation.visible && (
                <CustomAutocomplete
                  onChange={handleSubOccupationChange}
                  setFieldTouched={setFieldTouched}
                  label={generalProposerDetailsSchema.subOccupation.label}
                  name="subOccupation"
                  value={values.subOccupation!}
                  setFieldValue={setFieldValue}
                  error={errors.subOccupation}
                  touched={touched.subOccupation}
                  options={subOccupationOptions}
                />
              )}

            {generalProposerDetailsSchema.nameOfOrganization.visible &&
              !(partners.JIO === partnerId && ["SE", ""].includes(values.occupationCode!)) && (
                <CustomTextField
                  requiredStar={generalProposerDetailsSchema.nameOfOrganization.required}
                  label={generalProposerDetailsSchema.nameOfOrganization.label}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.nameOfOrganization}
                  name="nameOfOrganization"
                  error={getIn(errors, "nameOfOrganization")}
                  touched={getIn(touched, "nameOfOrganization")}
                />
              )}

            {!["SE", "OT", ""].includes(values.occupationCode!) &&
              generalProposerDetailsSchema.designation.visible && (
                <CustomTextField
                  requiredStar={generalProposerDetailsSchema.designation.required}
                  label={generalProposerDetailsSchema.designation.label}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.designation}
                  name="designation"
                  error={getIn(errors, "designation")}
                  touched={getIn(touched, "designation")}
                />
              )}

            {generalProposerDetailsSchema.annualIncome.visible && (
              <CustomTextField
                requiredStar={
                  generalProposerDetailsSchema.annualIncome.required || !values.housewifeFlag
                }
                disabledField={
                  values.housewifeFlag || generalProposerDetailsSchema?.annualIncome?.disabled
                }
                label={generalProposerDetailsSchema.annualIncome.label}
                onChange={(event) => handelIndianCurrencyChange(event, { setFieldValue })}
                handleBlur={handleBlur}
                value={onChangeIndianCurrency(values?.annualIncome!)}
                name="annualIncome"
                error={errors?.annualIncome}
                touched={touched?.annualIncome}
              />
            )}

            {generalProposerDetailsSchema.panNo.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.panNo.label}
                onChange={(e) => {
                  handleUppercaseChange(e, handleChange);
                }}
                handleBlur={handleBlur}
                name="panNo"
                value={values.panNo}
                error={errors.panNo}
                touched={touched.panNo}
              />
            )}

            {generalProposerDetailsSchema.natureOfWork.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.natureOfWork.required}
                label={generalProposerDetailsSchema.natureOfWork.label}
                options={OPTIONS.natureOfWork}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="natureOfWork"
                value={values.natureOfWork}
                error={errors.natureOfWork}
                touched={touched.natureOfWork}
              />
            )}

            {generalProposerDetailsSchema.relationship.visible && (
              <CustomSelect
                requiredStar={generalProposerDetailsSchema.relationship.required}
                disabledField={generalProposerDetailsSchema.relationship.disabled}
                label={generalProposerDetailsSchema.relationship.label}
                options={["Self"]}
                onChange={handleChange}
                setFieldTouched={setFieldTouched}
                name="relationship"
                value={values?.relationship!}
                error={errors?.relationship}
                touched={touched?.relationship}
              />
            )}

            {generalProposerDetailsSchema.UIDNo.visible && (
              <CustomTextField
                label={generalProposerDetailsSchema.UIDNo.label}
                onChange={handleChange}
                handleBlur={handleBlur}
                value={values.UIDNo}
                name="UIDNo"
                error={getIn(errors, "UIDNo")}
                touched={getIn(touched, "UIDNo")}
              />
            )}

            {generalProposerDetailsSchema.electronicAccount.visible && (
              <Tooltip
                title="Do you have Electronic Insurance Account *"
                placement="top"
                classes={{ tooltipPlacementTop: "!m-0.5" }}
                PopperProps={{
                  className: "!z-0"
                }}
              >
                <div>
                  <CustomSelect
                    requiredStar={generalProposerDetailsSchema.electronicAccount.required}
                    label={generalProposerDetailsSchema.electronicAccount.label}
                    options={OPTIONS.electronicAccount}
                    onChange={handleChange}
                    setFieldTouched={setFieldTouched}
                    name="electronicAccount"
                    value={values?.electronicAccount}
                    error={errors?.electronicAccount}
                    touched={touched?.electronicAccount}
                  />
                </div>
              </Tooltip>
            )}

            {values?.electronicAccount === "Yes" &&
              generalProposerDetailsSchema.eiaNumber.visible && (
                <CustomTextField
                  requiredStar={generalProposerDetailsSchema.eiaNumber.required}
                  label={generalProposerDetailsSchema.eiaNumber.label}
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  name="eiaNumber"
                  value={values?.eiaNumber!}
                  error={errors.eiaNumber}
                  touched={touched.eiaNumber}
                />
              )}
          </div>

          {["BO", "SE"].includes(values.occupationCode!) &&
            generalProposerDetailsSchema.businessOwner.visible && (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-6 mt-6">
                <div className="flex flex-col">
                  <CustomCheckBox
                    label={generalProposerDetailsSchema.businessOwner.label}
                    name="businessOwner"
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    checked={values?.businessOwner}
                  />
                  <div className="text-xs text-gray-500 mt-1">
                    This selection is for internal reference only. Please update if you do not fall
                    under SME category.
                  </div>
                </div>
              </div>
            )}

          <div>
            {!isJointLife && isNotProportionateParentLife && (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6 mt-6">
                  {generalProposerDetailsSchema.isJointJourney.visible && (
                    <CustomCheckBox
                      label={generalProposerDetailsSchema.isJointJourney.label}
                      name="isJointJourney"
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      checked={values?.isJointJourney}
                      onChange={() => handleCheckboxChange("isJointJourney")}
                    />
                  )}

                  {generalProposerDetailsSchema.isProportionateLife.visible && (
                    <CustomCheckBox
                      label={generalProposerDetailsSchema.isProportionateLife.label}
                      name="isProportionateLife"
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      checked={values?.isProportionateLife}
                      onChange={() => handleCheckboxChange("isProportionateLife")}
                    />
                  )}
                </div>
                {values.isProportionateLife && (
                  <div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6 mt-6">
                      <CustomTextField
                        requiredStar={true}
                        label={"Sum Assured"}
                        onChange={handlePrimarySumAssuredChange}
                        handleBlur={handleBlur}
                        name="primarySumAssured"
                        value={values?.primarySumAssured ?? ""}
                        error={errors.primarySumAssured}
                        touched={touched.primarySumAssured}
                      />

                      {generalProposerDetailsSchema.totalLoanAmountOpted.visible && (
                        <CustomTextField
                          requiredStar={generalProposerDetailsSchema.totalLoanAmountOpted.required}
                          label={generalProposerDetailsSchema.totalLoanAmountOpted.label}
                          onChange={(event) => handelIndianCurrencyChange(event, { setFieldValue })}
                          handleBlur={handleBlur}
                          name="totalLoanAmountOpted"
                          value={onChangeIndianCurrency(values.totalLoanAmountOpted || "")}
                          error={errors?.totalLoanAmountOpted}
                          touched={touched?.totalLoanAmountOpted}
                        />
                      )}
                    </div>
                    <div>
                      <Formik onSubmit={() => formik.handleSubmit()} {...formik}>
                        <Form>
                          <div className="py-8">
                            <div className="mb-10 w-full border border-black opacity-30" />
                            <FieldArray
                              name="proportionate"
                              render={() => (
                                <div>
                                  {values.proportionate && values.proportionate.length > 0
                                    ? values.proportionate.map((item, index) => (
                                        <ProportionateLife
                                          formik={formik}
                                          key={`proportionate${index}`}
                                          proportionateNumber={index}
                                          onRemoveClick={() => handleRemoveClick(index)}
                                          value={item}
                                          proportionateError={{
                                            get: sharePercentErrorStatus,
                                            set: setSharePercentErrorStatus
                                          }}
                                        />
                                      ))
                                    : null}
                                  {
                                    <Button
                                      className="add-more-button"
                                      onClick={handleAddingMoreProportionate}
                                      disabled={
                                        values.proportionate && values.proportionate.length >= 4
                                      }
                                    >
                                      + Add More Proportionate (Max. 4)
                                    </Button>
                                  }
                                </div>
                              )}
                            ></FieldArray>
                          </div>
                        </Form>
                      </Formik>
                    </div>
                  </div>
                )}

                <div>
                  {values?.isJointJourney && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6 mt-6">
                      {generalProposerDetailsSchema.jointFirstName.visible && (
                        <CustomTextField
                          requiredStar={generalProposerDetailsSchema.jointFirstName.required}
                          label={generalProposerDetailsSchema.jointFirstName.label}
                          onChange={handleChange}
                          handleBlur={handleBlur}
                          value={values?.jointFirstName!}
                          name="jointFirstName"
                          error={getIn(errors, "jointFirstName")}
                          touched={getIn(touched, "jointFirstName")}
                        />
                      )}

                      {generalProposerDetailsSchema.jointMiddleName.visible && (
                        <CustomTextField
                          label={generalProposerDetailsSchema.jointMiddleName.label}
                          onChange={handleChange}
                          handleBlur={handleBlur}
                          value={values?.jointMiddleName!}
                          name="jointMiddleName"
                          error={errors?.jointMiddleName}
                          touched={touched?.jointMiddleName}
                        />
                      )}

                      {generalProposerDetailsSchema.jointLastName.visible && (
                        <CustomTextField
                          label={generalProposerDetailsSchema.jointLastName.label}
                          onChange={handleChange}
                          handleBlur={handleBlur}
                          value={values?.jointLastName!}
                          name="jointLastName"
                          error={errors?.jointLastName}
                          touched={touched?.jointLastName}
                        />
                      )}

                      {generalProposerDetailsSchema.jointDob.visible && (
                        <CustomDatePicker
                          disableFuture
                          requiredStar={generalProposerDetailsSchema.jointDob.required}
                          label={generalProposerDetailsSchema.jointDob.label}
                          setFieldValue={setFieldValue}
                          name="jointDob"
                          value={values?.jointDob}
                          error={errors?.jointDob}
                          touched={touched?.jointDob}
                          setFieldTouched={setFieldTouched}
                        />
                      )}

                      {generalProposerDetailsSchema.jointMobileNo.visible && (
                        <CustomTextField
                          requiredStar={generalProposerDetailsSchema.jointMobileNo.required}
                          label={generalProposerDetailsSchema.jointMobileNo.label}
                          onChange={handleChange}
                          handleBlur={handleBlur}
                          value={values?.jointMobileNo!}
                          name="jointMobileNo"
                          error={errors?.jointMobileNo}
                          touched={touched?.jointMobileNo}
                        />
                      )}

                      {generalProposerDetailsSchema.jointAnnualIncome.visible && (
                        <div>
                          <CustomTextField
                            requiredStar={generalProposerDetailsSchema.jointAnnualIncome.required}
                            label={generalProposerDetailsSchema.jointAnnualIncome.label}
                            onChange={(event) =>
                              handelIndianCurrencyChange(event, { setFieldValue })
                            }
                            handleBlur={handleBlur}
                            value={onChangeIndianCurrency(values?.jointAnnualIncome!)}
                            name="jointAnnualIncome"
                            error={errors?.jointAnnualIncome}
                            touched={touched?.jointAnnualIncome}
                          />
                          {values.jointAnnualIncome?.includes(".") && !errors.jointAnnualIncome && (
                            <CustomHelperText>
                              It will be roundoff to {Math.round(Number(values.jointAnnualIncome))}
                            </CustomHelperText>
                          )}
                        </div>
                      )}

                      {generalProposerDetailsSchema.jointPan.visible && (
                        <CustomTextField
                          label={generalProposerDetailsSchema.jointPan.label}
                          onChange={(e) => {
                            handleUppercaseChange(e, handleChange);
                          }}
                          handleBlur={handleBlur}
                          name="jointPan"
                          value={values?.jointPan!}
                          error={errors?.jointPan}
                          touched={touched?.jointPan}
                        />
                      )}

                      {generalProposerDetailsSchema.jointGender.visible && (
                        <CustomRadioButton
                          requiredStar={generalProposerDetailsSchema.jointGender.required}
                          className="col-span-1 sm:col-span-1 md:col-span-2 lg:col-span-3"
                          name="jointGender"
                          label={generalProposerDetailsSchema.jointGender.label}
                          options={genderDataList}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          error={getIn(errors, "jointGender")}
                          touched={getIn(touched, "jointGender")}
                          defaultValue={values?.jointGender}
                        />
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="mt-10 flex justify-center">
          <Button
            variant="outlined"
            classes={{ outlined: "!rounded-lg" }}
            onClick={() => {
              dispatch(setStepDetails({ parentStepNo: 1 }));
              window.scrollTo(0, 0);
            }}
            className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
          >
            Back
          </Button>
          <Button
            variant="contained"
            classes={{ contained: "!rounded-lg" }}
            onClick={handleProposerGeneralForm}
            className="!uppercase h-13 w-37.5"
          >
            NEXT
          </Button>
        </div>
      </div>
    </>
  );
}

export default memo(GeneralDetails);
